import React, { useState, useMemo } from "react";
import { Payout } from "../../pages";
import PayoutController from "../../controllers/PayoutController";

const PayoutContainer = () => {
  const [loading, setLoading] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [ignoreModal, setIgnoreModal] = useState(false);
  const [createPayout, setCreatePayout] = useState(false);
  const [approvalModal, setApprovalModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const PayoutTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = PayoutController.useGetPayout(
    PayoutTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToCreatePayout = () => {
    setCreatePayout(true);
  };

  const goToViewMore = () => {
    setViewMore(true);
  };

  const goToApproval = () => {
    setApprovalModal(true);
  };

  const goToIgnore = () => {
    setIgnoreModal(true);
  };

  const closeModal = () => {
    setSelectedIndex(-1);
    setCreatePayout(false);
    setViewMore(false);
    setApprovalModal(false);
    setIgnoreModal(false);
  };

  return (
    <Payout
      goToIgnore={goToIgnore}
      ignoreModal={ignoreModal}
      goToApproval={goToApproval}
      approvalModal={approvalModal}
      closeModal={closeModal}
      selectedIndex={selectedIndex}
      setSelectedIndex={setSelectedIndex}
      createPayout={createPayout}
      goToCreatePayout={goToCreatePayout}
      goToViewMore={goToViewMore}
      viewMore={viewMore}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
    />
  );
};
export default PayoutContainer;
